<template>
    <div>
        <div v-if="loading">
            <v-progress-linear
            indeterminate
            color="primary"
            ></v-progress-linear>
        </div>
        <v-card>
            <v-card-title>
                Settings
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-card>
                <v-card-title>
                  Publish Timing
                </v-card-title>
                <v-card-text>
                  <v-row justify="center">
                      <v-col
                          cols="md-6"
                      >
                          <v-card outlined>
                              <v-card-title>
                                  Subscriber Publish Timing
                              </v-card-title>
                              <v-card-subtitle>
                                  Post will be published for subscriber everyday at the time below
                              </v-card-subtitle>
                              <v-card-text class="d-flex justify-center">
                                  <v-time-picker
                                      format="ampm"
                                      v-model="serverData.sub_publish_timing"
                                      scrollable
                                  ></v-time-picker>
                              </v-card-text>
                              <v-card-actions>
                                  <v-spacer/>
                                  <v-btn
                                      color="primary"
                                      @click.stop="setSubPublishtiming"
                                  >Set</v-btn>
                              </v-card-actions>
                          </v-card>
                      </v-col>
                      <v-col
                          cols="md-6"
                      >
                          <v-card outlined>
                              <v-card-title>
                                  Non-Subscriber Publish Timing
                              </v-card-title>
                              <v-card-subtitle>
                                  Post will be published for non-subscriber everyday at the time below
                              </v-card-subtitle>
                              <v-card-text class="d-flex justify-center">
                                  <v-time-picker
                                      format="ampm"
                                      scrollable
                                      v-model="serverData.non_sub_publish_timing"
                                  ></v-time-picker>
                              </v-card-text>
                              <v-card-actions>
                                  <v-spacer/>
                                  <v-btn
                                      color="primary"
                                      @click.stop="setNonSubPublishTiming"
                                  >Set</v-btn>
                              </v-card-actions>
                          </v-card>
                      </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <br>
              <v-row justify="center">
                <v-col
                    cols="md-6"
                >
                  <v-card>
                    <v-card-title>Breaking News life span</v-card-title>
                    <v-card-subtitle>Duration (in hours) during which Breaking news is in an active state starting from the time it was created</v-card-subtitle>
                    <v-card-text>
                      <v-row no-gutters>
                        <v-col>
                          <v-text-field
                            filled
                            label="Duration (in hours)"
                            type="number"
                            prepend-icon="mdi-clock"
                            v-model="serverData.breaking_news_ttl"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="primary"
                        @click.stop="setBreakingNewsTTL"
                      >
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col
                  cols="md-6"
                >
<v-card>
                    <v-card-title>Just In News life span</v-card-title>
                    <v-card-subtitle>Duration (in hours) during which Just In news is in an active state starting from the time it was created</v-card-subtitle>
                    <v-card-text>
                      <v-row no-gutters>
                        <v-col>
                          <v-text-field
                            filled
                            label="Duration (in hours)"
                            type="number"
                            prepend-icon="mdi-clock"
                            v-model="serverData.justin_news_ttl"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="primary"
                        @click.stop="setJustInNewsTTL"
                      >
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <v-card>
                <v-card-title>
                  Promotion status
                </v-card-title>
                <v-card-subtitle>
                  When this status is in `on` state, subscriber and nonsubscriber will see an unrestricted news content.
                </v-card-subtitle>
                <v-card-text>
                  <v-switch
                    v-model="serverData.promotion_status"
                    :label="getPromotionStatusLabel()"
                    >
                  </v-switch>
                  <v-btn
                    color="primary"
                    @click.stop="updatePromotionStatus"
                  >Set</v-btn>
                </v-card-text>
              </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import settingsApi from '@/api/settingsApi'
import snackbar from '@/utils/snackbar'
export default {
  mounted () {
    this.fetchSettings()
  },
  data () {
    return {
      loading: false,
      settings: [],
      serverData: {
        sub_publish_timing: null,
        non_sub_publish_timing: null,
        breaking_news_ttl: null,
        promotion_status: false,
        justin_news_ttl: null
      }

    }
  },
  methods: {
    async fetchSettings () {
      this.loading = true
      try {
        const r = await settingsApi.getAll()
        this.$log.info('settings data', [r.data])
        if (r.data !== undefined) {
          this.settings = r.data
          const subPubTiming = this.settings.find((e) => e.name === 'sub_publish_timing')
          const nonSubPubTiming = this.settings.find((e) => e.name === 'non_sub_publish_timing')
          const breakingNewsTTL = this.settings.find((e) => e.name === 'breaking_news_ttl')
          const promotionStatus = this.settings.find((e) => e.name === 'promotion_status')
          const justInTTL = this.settings.find((e) => e.name === 'justin_news_ttl')

          if (justInTTL !== undefined) {
            this.serverData.justin_news_ttl = justInTTL.value
          }

          if (subPubTiming !== undefined) {
            this.serverData.sub_publish_timing = subPubTiming.value
          }

          if (nonSubPubTiming !== undefined) {
            this.serverData.non_sub_publish_timing = nonSubPubTiming.value
          }

          if (breakingNewsTTL !== undefined) {
            this.serverData.breaking_news_ttl = breakingNewsTTL.value
          }

          if (promotionStatus !== undefined) {
            this.serverData.promotion_status = promotionStatus.value === 'true'
          }
        }
      } finally {
        this.loading = false
      }
    },
    getPromotionStatusLabel () {
      if (this.serverData.promotion_status !== null) {
        if (this.serverData.promotion_status) {
          return 'on'
        }
      }
      return 'off'
    },
    async updatePromotionStatus () {
      this.$log.info('Update promotion status', [this.serverData.promotion_status])
      const params = { key: 'promotion_status', value: this.serverData.promotion_status }
      try {
        this.loading = true
        await settingsApi.updateOrCreate(params)
        snackbar.show('Promotion status updated successfully', 'success')
      } finally {
        this.fetchSettings()
        this.loading = false
      }
    },
    async setBreakingNewsTTL () {
      const params = { key: 'breaking_news_ttl', value: this.serverData.breaking_news_ttl }
      try {
        this.loading = true
        await settingsApi.updateOrCreate(params)
        snackbar.show('Breaking news life span updated successfully', 'success')
      } finally {
        this.fetchSettings()
        this.loading = false
      }
    },
    async setJustInNewsTTL () {
      const params = { key: 'justin_news_ttl', value: this.serverData.justin_news_ttl }
      try {
        this.loading = true
        await settingsApi.updateOrCreate(params)
        snackbar.show('Just In news life span updated successfully', 'success')
      } finally {
        this.fetchSettings()
        this.loading = false
      }
    },

    async setSubPublishtiming () {
      const params = { key: 'sub_publish_timing', value: this.serverData.sub_publish_timing }
      try {
        this.loading = true
        await settingsApi.updateOrCreate(params)
        snackbar.show('Publish timing for subscriber updated successfully', 'success')
      } finally {
        this.fetchSettings()
        this.loading = false
      }
    },
    async setNonSubPublishTiming () {
      const params = { key: 'non_sub_publish_timing', value: this.serverData.non_sub_publish_timing }
      try {
        this.loading = true
        await settingsApi.updateOrCreate(params)
        snackbar.show('Publish timing for non-subscriber updated successfully', 'success')
      } finally {
        this.fetchSettings()
        this.loading = false
      }
    }
  }
}
</script>
